export const saf = [
  {
    "titulo_item_nombre": "TERCER TRIMESTRE 2026 (Publicación: 30/Octubre/2026)",
    "archivos": [
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "NIVEL FINANCIERO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/TERCER TRIMESTRE 2026/Reporte por ejercicio del gasto 3er trimestre 2026.xlsx"
      },
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "POR PROYECTO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/TERCER TRIMESTRE 2026/Reporte por proyecto 3er trimestre 2026.xlsx"
      }
    ]
  },
  {
    "titulo_item_nombre": "SEGUNDO TRIMESTRE 2026",
    "archivos": [
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "NIVEL FINANCIERO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/SEGUNDO TRIMESTRE 2026/Reporte por ejercicio del gasto 2do trimestre 2026.xlsx"
      },
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "POR PROYECTO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/SEGUNDO TRIMESTRE 2026/Reporte por proyecto 2do trimestre 2026.xlsx"
      }
    ]
  },
  {
    "titulo_item_nombre": "PRIMER TRIMESTRE 2026",
    "archivos": [
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "NIVEL FINANCIERO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/PRIMER TRIMESTRE 2026/Reporte por ejercicio del gasto 1er trimestre 2026.xlsx"
      },
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "POR PROYECTO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/PRIMER TRIMESTRE 2026/Reporte por proyecto 1er trimestre 2026.xlsx"
      }
    ]
  },
  {
    "titulo_item_nombre": "INFORME DEFINITIVO 2025",
    "archivos": [
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "NIVEL FINANCIERO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/CUARTO TRIMESTRE 2025/ReporteFinal Ejercicio del gasto.xlsx"
      },
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "POR PROYECTO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/CUARTO TRIMESTRE 2025/ReporteFinal Proyectos.xlsx"
      }
    ]
  },
  {
    "titulo_item_nombre": "CUARTO TRIMESTRE 2025",
    "archivos": [
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "NIVEL FINANCIERO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/CUARTO TRIMESTRE 2025/Reporte por ejercicio del gasto 4to trimestre 2025.xlsx"
      },
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "POR PROYECTO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/CUARTO TRIMESTRE 2025/Reporte por proyecto 4to trimestre 2025.xlsx"
      }
    ]
  },
  {
    "titulo_item_nombre": "TERCER TRIMESTRE 2025",
    "archivos": [
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "NIVEL FINANCIERO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/TERCER TRIMESTRE 2025/Reporte por ejercicio del gasto 3er trimestre 2025.xlsx"
      },
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "POR PROYECTO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/TERCER TRIMESTRE 2025/Reporte por proyecto 3er trimestre 2025.xlsx"
      }
    ]
  }, 
  {
    "titulo_item_nombre": "SEGUNDO TRIMESTRE 2025",
    "archivos": [
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "NIVEL FINANCIERO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/SEGUNDO TRIMESTRE 2025/Reporte por ejercicio del gasto 2do trimestre 2025.xlsx"
      },
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "POR PROYECTO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/SEGUNDO TRIMESTRE 2025/Reporte por proyecto 2do trimestre 2025.xlsx"
      }
    ]
  },
  {
    "titulo_item_nombre": "PRIMER TRIMESTRE 2025",
    "archivos": [
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "NIVEL FINANCIERO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/PRIMER TRIMESTRE 2025/ReporteFinal Ejercicio del gasto.xlsx"
      },
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "POR PROYECTO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/PRIMER TRIMESTRE 2025/ReporteFinal Proyectos.xlsx"
      }
    ]
  },
  {
    "titulo_item_nombre": "INFORME DEFINITIVO 2024",
    "archivos": [
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "NIVEL FINANCIERO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/CUARTO TRIMESTRE 2024/ReporteFinal Ejercicio del gasto.xlsx"
      },
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "POR PROYECTO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/CUARTO TRIMESTRE 2024/ReporteFinal Proyectos.xlsx"
      }
    ]
  },
  {
    "titulo_item_nombre": "CUARTO TRIMESTRE 2024",
    "archivos": [
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "NIVEL FINANCIERO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/CUARTO TRIMESTRE 2024/Reporte por ejercicio del gasto 4to trimestre 2024.xlsx"
      },
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "POR PROYECTO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/CUARTO TRIMESTRE 2024/Reporte por proyecto 4to trimestre 2024.xlsx"
      }
    ]
  },
  {
    "titulo_item_nombre": "TERCER TRIMESTRE 2024",
    "archivos": [
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "NIVEL FINANCIERO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/TERCER TRIMESTRE 2024/ReporteFinal Ejercicio del gasto.xlsx"
      },
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "POR PROYECTO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/TERCER TRIMESTRE 2024/ReporteFinal Proyectos.xlsx"
      }
    ]
  },
  {
    "titulo_item_nombre": "SEGUNDO TRIMESTRE 2024",
    "archivos": [
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "NIVEL FINANCIERO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/SEGUNDO TRIMESTRE 2024/ReporteFinal Ejercicio del gasto.xlsx"
      },
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "POR PROYECTO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/SEGUNDO TRIMESTRE 2024/ReporteFinal Proyectos.xlsx"
      }
    ]
  },
  {
    "titulo_item_nombre": "PRIMER TRIMESTRE 2024",
    "archivos": [
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "NIVEL FINANCIERO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/PRIMER TRIMESTRE 2024/Hidalgo_Ejercicio del Gasto_Primer Trimestre 2024.xlsx"
      },
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "POR PROYECTO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/PRIMER TRIMESTRE 2024/Hidalgo_Destino del Gasto_Primer Trimestre 2024 .xlsx"
      }
    ]
  },
  {
    "titulo_item_nombre": "INFORME DEFINITIVO 2023",
    "archivos": [
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "NIVEL FINANCIERO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/CUARTO TRIMESTRE 2023/ReporteFinal Ejercicio del gasto.xlsx"
      },
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "POR PROYECTO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/CUARTO TRIMESTRE 2023/ReporteFinal Proyectos.xlsx"
      }
    ]
  },
  {
    "titulo_item_nombre": "CUARTO TRIMESTRE 2023",
    "archivos": [
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "NIVEL FINANCIERO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/CUARTO TRIMESTRE 2023/Reporte por ejercicio del gasto 4to trimestre 2023.xlsx"
      },
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "POR PROYECTO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/CUARTO TRIMESTRE 2023/Reporte por proyecto 4to trimestre 2023.xlsx"
      }
    ]
  },
  {
    "titulo_item_nombre": "TERCER TRIMESTRE 2023",
    "archivos": [
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "NIVEL FINANCIERO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/TERCER TRIMESTRE 2023/Reporte por ejercicio del gasto 3er trimestre 2023.xlsx"
      },
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "POR PROYECTO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/TERCER TRIMESTRE 2023/Reporte por proyecto 3er trimestre 2023.xlsx"
      }
    ]
  },
  {
    "titulo_item_nombre": "SEGUNDO TRIMESTRE 2023",
    "archivos": [
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "NIVEL FINANCIERO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/SEGUNDO TRIMESTRE 2023/Reporte-Ejercicio del gasto-2do-trim-2023.xlsx"
      },
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "POR PROYECTO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/SEGUNDO TRIMESTRE 2023/Reporte-proyectos-2do-trim-2023.xlsx"
      }
    ]
  },
  {
    "titulo_item_nombre": "PRIMER TRIMESTRE 2023",
    "archivos": [
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "NIVEL FINANCIERO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/PRIMER TRIMESTRE 2023/Ejercicio del Gasto Nivel Financiero Primer Trimestre 2023.xlsx"
      },
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "POR PROYECTO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/PRIMER TRIMESTRE 2023/Proyectos Primer Trimestre 2023 Salud.xlsx"
      }
    ]
  },
  {
    "titulo_item_nombre": "INFORME DEFINITIVO 2022",
    "archivos": [
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "NIVEL FINANCIERO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/CUARTO TRIMESTRE 2022/Reporte-Ejercicio del gasto-Inf-Def-2022.xlsx"
      },
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "POR PROYECTO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/CUARTO TRIMESTRE 2022/Reporte-proyectos-Inf-Def-2022.xlsx"
      }
    ]
  },
  {
    "titulo_item_nombre": "CUARTO TRIMESTRE 2022",
    "archivos": [
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "NIVEL FINANCIERO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/CUARTO TRIMESTRE 2022/Ejercicio del Gasto Nivel Financiero Cuarto Trimestre 2022.xlsx"
      },
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "POR PROYECTO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/CUARTO TRIMESTRE 2022/Proyectos Cuarto Trimestre 2022 Salud.xlsx"
      }
    ]
  },
  {
    "titulo_item_nombre": "TERCER TRIMESTRE 2022",
    "archivos": [
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "NIVEL FINANCIERO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/TERCER TRIMESTRE 2022/NIVEL FINANCIERO SERVICIOS DE SALUD 3er.TRIMESTRE-2022.xlsx"
      },
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "POR PROYECTO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/TERCER TRIMESTRE 2022/POR PROYECTO SERVICIOS DE SALUD 3ER.TRIMESTRE-2022.xlsx"
      }
    ]
  },
  {
    "titulo_item_nombre": "SEGUNDO TRIMESTRE 2022",
    "archivos": [
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "NIVEL FINANCIERO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/SEGUNDO TRIMESTRE 2022/NIVEL FINANCIERO SERVICIOS DE SALUD 2DO.TRIMESTRE-2022.xls"
      },
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "POR PROYECTO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/SEGUNDO TRIMESTRE 2022/POR PROYECTO SERVICIOS DE SALUD 2DO.TRIMESTRE-2022.xlsx"
      }
    ]
  },
  {
    "titulo_item_nombre": "PRIMER TRIMESTRE 2022",
    "archivos": [
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "NIVEL FINANCIERO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/PRIMER TRIMESTRE 2022/NIVEL FINANCIERO SERVICIOS DE SALUD 1er.trimestre-2022.xls"
      },
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "POR PROYECTO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/PRIMER TRIMESTRE 2022/POR PROYECTO SERVICIOS DE SALUD 1er.trimestre-2022.xlsx"
      }
    ]
  },
  {
    "titulo_item_nombre": "INFORME DEFINITIVO 2021",
    "archivos": [
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "NIVEL FINANCIERO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/CUARTO TRIMESTRE 2021/NIVEL FINANCIERO SERVICIOS DE SALUD INFORME DEFINITIVO-2021.xls"
      }
    ]
  },
  {
    "titulo_item_nombre": "CUARTO TRIMESTRE 2021",
    "archivos": [
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "NIVEL FINANCIERO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/CUARTO TRIMESTRE 2021/NIVEL FINANCIERO SERVICIOS DE SALUD 4to.trimestre-2021.xls"
      },
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "POR PROYECTO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/CUARTO TRIMESTRE 2021/POR PROYECTO SERVICIOS DE SALUD 4to.trimestre-2021.xlsx"
      }
    ]
  },
  {
    "titulo_item_nombre": "TERCER TRIMESTRE 2021",
    "archivos": [
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "NIVEL FINANCIERO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/TERCER TRIMESTRE 2021/NIVEL FINANCIERO 3er-trim2021.xlsx"
      },
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "POR PROYECTO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/TERCER TRIMESTRE 2021/Nivel Proyectos 3er Trim -2021.xlsx"
      }
    ]
  },
  {
    "titulo_item_nombre": "SEGUNDO TRIMESTRE 2021",
    "archivos": [
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "NIVEL FINANCIERO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/SEGUNDO TRIMESTRE 2021/NIVEL FINANCIERO 2do.trimestre 2021.xlsx"
      },
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "POR PROYECTO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/SEGUNDO TRIMESTRE 2021/NIVEL PROYECTO 2do trimestre 2021.xlsx"
      }
    ]
  },
  {
    "titulo_item_nombre": "PRIMER TRIMESTRE 2021",
    "archivos": [
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "NIVEL FINANCIERO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/PRIMER TRIMESTRE 2021/NIVEL FINANCIERO SERVICIOS DE SALUD 1t 2021.xlsx"
      },
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "POR PROYECTO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/PRIMER TRIMESTRE 2021/POR PROYECTO SERVICIOS DE SALUD 1t 2021.xlsx"
      }
    ]
  },
  {
    "titulo_item_nombre": "INFORME DEFINITIVO 2020",
    "archivos": [
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "NIVEL FINANCIERO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/CUARTO TRIMESTRE 2020/NIVEL FINANCIERO INFORME DEFINITIVO 2020.xlsx"
      },
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "POR PROYECTO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/CUARTO TRIMESTRE 2020/NIVEL PROYECTO INFORME DEFINITIVO 2020.xlsx"
      }
    ]
  },
  {
    "titulo_item_nombre": "CUARTO TRIMESTRE 2020",
    "archivos": [
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "NIVEL FINANCIERO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/CUARTO TRIMESTRE 2020/Reporte de Nivel Financiero 4to Trimestre 2020.xlsx"
      },
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "POR PROYECTO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/CUARTO TRIMESTRE 2020/Reporte de PROYECTOS 4to Trimestre 2020.xlsx"
      }
    ]
  },
  {
    "titulo_item_nombre": "TERCER TRIMESTRE 2020",
    "archivos": [
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "NIVEL FINANCIERO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/TERCER TRIMESTRE 2020/Reporte 3er Trimestre Nivel Financiero.xlsx"
      },
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "POR PROYECTO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/TERCER TRIMESTRE 2020/Reporte 3er Trimestre Nivel Proyectos.xlsx"
      }
    ]
  },
  {
    "titulo_item_nombre": "SEGUNDO TRIMESTRE 2020",
    "archivos": [
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "NIVEL FINANCIERO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/SEGUNDO TRIMESTRE 2020/Nivel Financiero 2do trimestre 2020.xlsx"
      },
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "POR PROYECTO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/SEGUNDO TRIMESTRE 2020/Gestion de Proyectos 2do trimestre 2020.xlsx"
      }
    ]
  },
  {
    "titulo_item_nombre": "PRIMER TRIMESTRE 2020",
    "archivos": [
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "NIVEL FINANCIERO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/PRIMER TRIMESTRE 2020/REPORTE Nivel Financiero 1er Trim 2020.xlsx"
      },
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "POR PROYECTO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/PRIMER TRIMESTRE 2020/REPROTE DE PROYECTOS 1ER TRIM 2020.xlsx"
      }
    ]
  },
  {
    "titulo_item_nombre": "Publicación del Informe Definitivo 2019, de los Servicios de Salud de Hidalgo (Gestión de Proyectos y Avance Financiero) en el Periódico Oficial del Estado de Hidalgo",
    "archivos": [
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "Nivel Financiero Informe definitivo 2019",
        "file_item_url": "../../contenido/transparencia/saf/Nivel Financiero Informe definitivo 2019.xlsx"
      },
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "Gestion de proyectos informe definitivo-2019",
        "file_item_url": "../../contenido/transparencia/saf/Gestion de proyectos informe definitivo-2019.xlsx"
      }
    ]
  },
  {
    "titulo_item_nombre": "CUARTO TRIMESTRE 2019",
    "archivos": [
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "NIVEL FINANCIERO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/CUARTO TRIMESTRE 2019/Reporte Nivel Financiero 4to-trim2019.xlsx"
      },
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "POR PROYECTO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/CUARTO TRIMESTRE 2019/Reporte Nivel Proyectos 4to-trim-2019.xlsx"
      }
    ]
  },
  {
    "titulo_item_nombre": "TERCER TRIMESTRE 2019",
    "archivos": [
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "NIVEL FINANCIERO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/TERCER TRIMESTRE 2019/Nivel Financiero 3er Trimestre 2019.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "POR PROYECTO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/TERCER TRIMESTRE 2019/Nivel Proyecto 3er Trimestre 2019.pdf"
      }
    ]
  },
  {
    "titulo_item_nombre": "SEGUNDO TRIMESTRE 2019",
    "archivos": [
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "NIVEL FINANCIERO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/SEGUNDO TRIMESTRE 2019/Reporte Nivel Financiero 2do T 2019.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "POR PROYECTO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/SEGUNDO TRIMESTRE 2019/Reporte Nivel Proyectos 2do T 2019.pdf"
      }
    ]
  },
  {
    "titulo_item_nombre": "PRIMER TRIMESTRE 2019",
    "archivos": [
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "NIVEL FINANCIERO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/PRIMER TRIMESTRE 2019/Reporte de Nivel Financiero  Servicios de Salud de Hidalgo 1er Trimestre 2019.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "POR PROYECTO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/PRIMER TRIMESTRE 2019/Reporte de Nivel Proyecto Servicios de Salud de Hidalgo 1er Trimestre 2019.pdf"
      }
    ]
  },
  {
    "titulo_item_nombre": "CUARTO TRIMESTRE 2018",
    "archivos": [
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "NIVEL FINANCIERO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/4TO TRIMESTRE 2018/NIVEL FINANCIERO 4t.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "POR PROYECTO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/4TO TRIMESTRE 2018/PROYECTO 4t.pdf"
      }
    ]
  },
  {
    "titulo_item_nombre": "TERCER TRIMESTRE 2018",
    "archivos": [
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "NIVEL FINANCIERO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/3ER TRIMESTRE 2018/Publicacion Nivel Financiero 3er trimestre Servicios de Salud.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "POR PROYECTO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/3ER TRIMESTRE 2018/Publicacion Proyectos 3er trimestre Servicios de Salud.pdf"
      }
    ]
  },
  {
    "titulo_item_nombre": "SEGUNDO TRIMESTRE 2018",
    "archivos": [
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "NIVEL FINANCIERO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/2DO TRIMESTRE 2018/Servicios de Salud Financiero 2 trimestre.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "POR PROYECTO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/2DO TRIMESTRE 2018/Servicios de Salud Proyectos 2 trimestre.pdf"
      }
    ]
  },
  {
    "titulo_item_nombre": "SEGUNDO CONVENIO MODIFICATORIO AL CONVENIO ESPECÍFICO EN MATERIA DE MINISTRACIÓN DE SUBSIDIOS PARA EL FORTALECIMIENTO DE ACCIONES DE SALUD PÚBLICA EN LAS ENTIDADES FEDERATIVAS, AFASPE 2018",
    "archivos": [
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "Convenio 02-CM-AFASPE-HGO/2018",
        "file_item_url": "../../contenido/transparencia/saf/Convenios/Convenio 02 CM AFASPE HGO 2018.pdf"
      }
    ]
  },
  {
    "titulo_item_nombre": "Publicación del Informe Definitivo 2017, de los Servicios de Salud de Hidalgo (Gestión de Proyectos y Avance Financiero) en el Periódico Oficial del Estado de Hidalgo",
    "archivos": [
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "Publicación del Informe Definitivo 2017",
        "file_item_url": "../../contenido/transparencia/saf/Publicacion del Informe Definitivo 2017.pdf"
      }
    ]
  },
  {
    "titulo_item_nombre": "PRIMER TRIMESTRE 2018",
    "archivos": [
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "NIVEL FINANCIERO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/1ER TRIMESTRE 2018/Nivel Financiero.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "POR PROYECTO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/1ER TRIMESTRE 2018/Nivel Proyectos.pdf"
      }
    ]
  },
  {
    "titulo_item_nombre": "CUARTO TRIMESTRE 2017",
    "archivos": [
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "NIVEL FINANCIERO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/4TO TRIMESTRE 2017/Nivel Financiero.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "POR PROYECTO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/4TO TRIMESTRE 2017/Nivel Proyectos.pdf"
      }
    ]
  },
  {
    "titulo_item_nombre": "TERCER TRIMESTRE 2017",
    "archivos": [
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "NIVEL FINANCIERO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/3ER TRIMESTRE 2017/NIVEL FINANCIERO 3ER TRIMESTRE.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "POR PROYECTO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/3ER TRIMESTRE 2017/GESTION DE PROYECTOS 3ER TRIMESTRE.pdf"
      }
    ]
  },
  {
    "titulo_item_nombre": "SEGUNDO TRIMESTRE 2017",
    "archivos": [
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "NIVEL FINANCIERO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/2DO TRIMESTRE 2017/SERVICIOS FINANCIERO.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "POR PROYECTO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/2DO TRIMESTRE 2017/SERVICIOS PROYECTOS.pdf"
      }
    ]
  },
  {
    "titulo_item_nombre": "PRIMER TRIMESTRE 2017",
    "archivos": [
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "NIVEL FINANCIERO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/1ER TRIMESTRE 2017/FINANCIERO - SERVICIOS.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "POR PROYECTO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/1ER TRIMESTRE 2017/PROYECTOS - SERVICIOS.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "NIVEL FINANCIERO SECRETARIA DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/1ER TRIMESTRE 2017/FINANCIERO - SECRETARIA.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "POR PROYECTO SECRETARIA DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/1ER TRIMESTRE 2017/PROYECTOS - SECRETARIA.pdf"
      }
    ]
  },
  {
    "titulo_item_nombre": "INFORME DEFINITIVO 2016",
    "archivos": [
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "FINANCIERO SECRETARIA DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/4TO TRIMESTRE 2016/SECRETARIA FINANCIERO DEF.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "PROYECTO SECRETARIA DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/4TO TRIMESTRE 2016/SECRETARIA PROYECTOS DEF.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "FINANCIERO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/4TO TRIMESTRE 2016/SERVICIOS FINANCIERO DEF.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "PROYECTO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/4TO TRIMESTRE 2016/SERVICIOS PROYECTOS DEF.pdf"
      }
    ]
  },
  {
    "titulo_item_nombre": "CUARTO TRIMESTRE 2016",
    "archivos": [
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "FINANCIERO SECRETARIA DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/4TO TRIMESTRE 2016/FINANCIERO SECRETARIA DE SALUD.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "PROYECTO SECRETARIA DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/4TO TRIMESTRE 2016/PROYECTOS SECRETARIA DE SALUD.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "FINANCIERO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/4TO TRIMESTRE 2016/FINANCIERO SERVICIOS DE SALUD.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "PROYECTO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/4TO TRIMESTRE 2016/PROYECTOS SERVICIOS DE SALUD.pdf"
      }
    ]
  },
  {
    "titulo_item_nombre": "TERCER TRIMESTRE 2016",
    "archivos": [
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "FINANCIERO SECRETARIA DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/3ER TRIMESTRE 2016/PDF SECRETARIA DE SALUD FINANCIERO.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "PROYECTO SECRETARIA DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/3ER TRIMESTRE 2016/PDF SECRETARIA DE SALUD proyecto.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "FINANCIERO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/3ER TRIMESTRE 2016/PDF SERVICIOS DE SALUD FINANCIERO.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "PROYECTO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/3ER TRIMESTRE 2016/PDF SERVICIOS DE SALUD proyecto.pdf"
      }
    ]
  },
  {
    "titulo_item_nombre": "SEGUNDO TRIMESTRE 2016",
    "archivos": [
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "INFORME DEFINITIVO 2015",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/2DO TRIMESTRE 2016/FINANCIERO 2015 .pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "POR PROYECTO 2015",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/2DO TRIMESTRE 2016/PROYECTO 2015.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "NIVEL FINANCIERO",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/2DO TRIMESTRE 2016/FINANCIERO 2016 .pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "POR PROYECTO",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/2DO TRIMESTRE 2016/PROYECTO 2016.pdf"
      }
    ]
  },
  {
    "titulo_item_nombre": "PRIMER TRIMESTRE 2016",
    "archivos": [
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "FINANCIERO SECRETARIA DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/1ER_TRIMESTRE_2016/NIVEL FINANCIERO SECRETARIA DE SALUD.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "PROYECTO SECRETARIA DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/1ER_TRIMESTRE_2016/PROYECTO SECRETARIA DE SALUD.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "FINANCIERO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/1ER_TRIMESTRE_2016/NIVEL FINANCIERO SERVICIOS DE SALUD.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "PROYECTO SERVICIOS DE SALUD",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/1ER_TRIMESTRE_2016/PROYECTO SERVICIOS DE SALUD.pdf"
      }
    ]
  },
  {
    "titulo_item_nombre": "OTRA INFORMACIÓN CONTABLE",
    "archivos": [
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "FORMATO DEL EJERCICIO Y DESTINO DEL GASTO",
        "file_item_url": "../../contenido/transparencia/saf/2015/Otra Informacion/FOR_4TO. TRIM. INFRA.pdf"
      }
    ]
  },
  {
    "titulo_item_nombre": "INFORMACIÓN PRESUPUESTAL",
    "archivos": [
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "ESTADO DEL EJERCICIO DEL PRESUPUESTO DE EGRESOS 1ER TRIM",
        "file_item_url": "../../contenido/transparencia/saf/2015/INFORMACION PRESUPUESTARIA/ESTADO DEL EJERCICIO DEL PRESUPUESTO DE EGRESOS 1ER TRIM.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "ESTADO ANALITICO DE INGRESOS 1ER TRIM",
        "file_item_url": "../../contenido/transparencia/saf/2015/INFORMACION PRESUPUESTARIA/ESTADO ANALITICO DE INGRESOS 1ER TRIM.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "ESTADO ANALITICO DE EGRESOS 2DO TRIM",
        "file_item_url": "../../contenido/transparencia/saf/2015/INFORMACION PRESUPUESTARIA/ESTADO ANALITICO DE EGRESOS 2DO TRIM.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "ESTADO ANALITICO DE INGRESOS 2DO TRIM",
        "file_item_url": "../../contenido/transparencia/saf/2015/INFORMACION PRESUPUESTARIA/ESTADO ANALITICO DE INGRESOS 2DO TRIM.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "ESTADO ANALITICO DE INGRESOS 3ER TRIM",
        "file_item_url": "../../contenido/transparencia/saf/2015/INFORMACION PRESUPUESTARIA/ESTADO ANALITICO DE INGRESOS 3ER TRIM.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "ESTADO ANALITICO DE EGRESOS 3ER TRIM",
        "file_item_url": "../../contenido/transparencia/saf/2015/INFORMACION PRESUPUESTARIA/ESTADO ANALITICO DE EGRESOS 3ER TRIM.pdf"
      }
    ]
  },
  {
    "titulo_item_nombre": "INFORMACIÓN CONTABLE TERCER TRIMESTRE 2015",
    "archivos": [
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "ESTADO DE SITUACION FINANCIERA",
        "file_item_url": "../../contenido/transparencia/saf/ESTADOS FINANCIEROS 3ER TRIM 2015/1. Estado de Situación Financiera.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "ESTADO DE ACTIVIDADES",
        "file_item_url": "../../contenido/transparencia/saf/ESTADOS FINANCIEROS 3ER TRIM 2015/2. Estado de Actividades.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "ESTADO DE FLUJOS DE EFECTIVO",
        "file_item_url": "../../contenido/transparencia/saf/ESTADOS FINANCIEROS 3ER TRIM 2015/3. Estado de Flujos de Efectivo.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "ESTADO DE VARIACION EN LA HACIENDA PUBLICA",
        "file_item_url": "../../contenido/transparencia/saf/ESTADOS FINANCIEROS 3ER TRIM 2015/4. Estado de Variación en la Hacienda Pública.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "ESTADO ANALITICO DE LA DEUDA Y OTROS PASIVOS",
        "file_item_url": "../../contenido/transparencia/saf/ESTADOS FINANCIEROS 3ER TRIM 2015/5. Estado Analitico de la Deuda y Otros Pasivos.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "ESTADO ANALITICO DEL ACTIVO",
        "file_item_url": "../../contenido/transparencia/saf/ESTADOS FINANCIEROS 3ER TRIM 2015/6. Estado Analitico del Activo.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "INFORME DE PASIVOS",
        "file_item_url": "../../contenido/transparencia/saf/ESTADOS FINANCIEROS 3ER TRIM 2015/7. Informe de Pasivos.pdf"
      }
    ]
  },
  {
    "titulo_item_nombre": "INFORMACIÓN CONTABLE SEGUNDO TRIMESTRE 2015",
    "archivos": [
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "ESTADO DE SITUACION FINANCIERA",
        "file_item_url": "../../contenido/transparencia/saf/ESTADOS FINANCIEROS 2DO TRIM 2015/1. ESTADO DE SITUACION FINANCIERA.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "ESTADO DE ACTIVIDADES",
        "file_item_url": "../../contenido/transparencia/saf/ESTADOS FINANCIEROS 2DO TRIM 2015/2. ESTADO DE ACTIVIDADES.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "ESTADO DE VARIACION EN LA HACIENDA PUBLICA",
        "file_item_url": "../../contenido/transparencia/saf/ESTADOS FINANCIEROS 2DO TRIM 2015/3. ESTADO DE VARIACION EN LA HACIENDA PUBLICA.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "ESTADO DE FLUJOS DE EFECTIVO",
        "file_item_url": "../../contenido/transparencia/saf/ESTADOS FINANCIEROS 2DO TRIM 2015/4. ESTADO DE FLUJOS DE EFECTIVO.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "ESTADO ANALITICO DE INGRESOS",
        "file_item_url": "../../contenido/transparencia/saf/ESTADOS FINANCIEROS 2DO TRIM 2015/5. ESTADO ANALITICO DE IGRESOS.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "ESTADO ANALITICO DE EGRESOS",
        "file_item_url": "../../contenido/transparencia/saf/ESTADOS FINANCIEROS 2DO TRIM 2015/6. ESTADO ANALITICO DE EGRESOS.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "ESTADO ANALITICO DEL ACTIVO",
        "file_item_url": "../../contenido/transparencia/saf/ESTADOS FINANCIEROS 2DO TRIM 2015/7. ESTADO ANALITICO DEL ACTIVO.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "ESTADO ANALITICO DE LA DEUDA Y OTROS PASIVOS",
        "file_item_url": "../../contenido/transparencia/saf/ESTADOS FINANCIEROS 2DO TRIM 2015/8. ESTADO ANALITICO DE LA DEUDA Y OTROS PASIVOS.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "INFORME DE PASIVOS CONT Y DEUDA PUBLICA",
        "file_item_url": "../../contenido/transparencia/saf/ESTADOS FINANCIEROS 2DO TRIM 2015/9. INFORME DE PASIVOS CONT Y DEUDA PUBLICA.pdf"
      }
    ]
  },
  {
    "titulo_item_nombre": "INFORMACIÓN CONTABLE PRIMER TRIMESTRE 2015",
    "archivos": [
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "ESTADO DE SITUACION FINANCIERA",
        "file_item_url": "../../contenido/transparencia/saf/ESTADOS FINANCIEROS 1ER TRIM 2015/1. ESTADO DE SITUACIÓN FINANCIERA.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "ESTADO DE ACTIVIDADES",
        "file_item_url": "../../contenido/transparencia/saf/ESTADOS FINANCIEROS 1ER TRIM 2015/2. ESTADO DE ACTIVIDADES.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "ESTADO DE FLUJO DE EFECTIVO",
        "file_item_url": "../../contenido/transparencia/saf/ESTADOS FINANCIEROS 1ER TRIM 2015/3. ESTADO DE FLUJO DE EFECTIVO.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "ESTADO DE VARIACIÓN EN LA HACIENDA PUBLICA",
        "file_item_url": "../../contenido/transparencia/saf/ESTADOS FINANCIEROS 1ER TRIM 2015/4. ESTADO DE VARIACIÓN EN LA HACIENDA PÚBLICA.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "ESTADO ANALITICO DEL ACTIVO",
        "file_item_url": "../../contenido/transparencia/saf/ESTADOS FINANCIEROS 1ER TRIM 2015/5. ESTADO ANALITICO DEL ACTIVO.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "ESTADO ANALITICO DE INGRESOS PRESUPUESTALES",
        "file_item_url": "../../contenido/transparencia/saf/ESTADOS FINANCIEROS 1ER TRIM 2015/6. ESTADO ANALITICO DE INGRESOS PRESUPUESTALES.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "ESTADO DEL EJERCICIO DEL PRESUPUESTO DE EGRESOS Y NOTAS",
        "file_item_url": "../../contenido/transparencia/saf/ESTADOS FINANCIEROS 1ER TRIM 2015/7. ESTADO DEL EJERCICIO DEL PRESUPUESTO DE EGRESOS Y NOTAS.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "NOTAS DE GESTION ADMINISTRATIVA",
        "file_item_url": "../../contenido/transparencia/saf/ESTADOS FINANCIEROS 1ER TRIM 2015/8. NOTAS DE GESTION ADMINISTRATIVA.pdf"
      }
    ]
  },
  {
    "titulo_item_nombre": "OTRA INFORMACIÓN CONTABLE",
    "archivos": [
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "Cuenta pública 2014",
        "file_item_url": "../../contenido/transparencia/saf/2014/OTRA INFORMACION/Cuenta publica 2014.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "INVENTARIO DE BIENES INMUEBLES",
        "file_item_url": "../../contenido/transparencia/saf/2014/OTRA INFORMACION/INVENTARIO DE BIENES INMUEBLES.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "Relacion de Bienes muebles 2014",
        "file_item_url": "../../contenido/transparencia/saf/2014/OTRA INFORMACION/Relacion de Bienes muebles 2014 completa.pdf"
      }
    ]
  },
  {
    "titulo_item_nombre": "INFORMACIÓN PRESUPUESTAL",
    "archivos": [
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "ESTADO ANALITICO DEL PRESUPUESTO DE EGRESOS 1ER TRIM",
        "file_item_url": "../../contenido/transparencia/saf/2014/INFORMACION PRESUPUESTARIA/ESTADO ANALITICO DEL PRESUPUESTO DE EGRESOS 1ER TRIM.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "ESTADO DEL EJERCICIO DEL PRESUPUESTO DE EGRESOS 2DO TRIM",
        "file_item_url": "../../contenido/transparencia/saf/2014/INFORMACION PRESUPUESTARIA/ESTADO DEL EJERCICIO DEL PRESUPUESTO DE EGRESOS 2DO TRIM.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "ESTADO DEL EJERCICIO DEL PRESUPUESTO DE EGRESOS 3ER TRIM",
        "file_item_url": "../../contenido/transparencia/saf/2014/INFORMACION PRESUPUESTARIA/ESTADO DEL EJERCICIO DEL PRESUPUESTO DE EGRESOS 3ER TRIM.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "ESTADO ANALITICO DE INGRESOS 4TO TRIM",
        "file_item_url": "../../contenido/transparencia/saf/2014/INFORMACION PRESUPUESTARIA/ESTADO ANALITICO DE INGRESOS 4TO TRIM.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "ESTADO ANALITICO DEL EJERCICIO DEL PRESUPUESTO DE EGRESOS 4TO TRIM",
        "file_item_url": "../../contenido/transparencia/saf/2014/INFORMACION PRESUPUESTARIA/ESTADO ANALITICO DEL EJERCICIO DEL PRESUPUESTO DE EGRESOS 4TO TRIM.pdf"
      }
    ]
  },
  {
    "titulo_item_nombre": "INFORMACIÓN CONTABLE CUARTO TRIMESTRE 2014",
    "archivos": [
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "1. ESTADO DE SITUACIÓN FINANCIERA",
        "file_item_url": "../../contenido/transparencia/saf/2014/INFORMACION CONTABLE/4TO TRIMESTRE/1. ESTADO DE SITUACION FINANCIERA.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "2. ESTADO DE ACTIVIDADES",
        "file_item_url": "../../contenido/transparencia/saf/2014/INFORMACION CONTABLE/4TO TRIMESTRE/2. ESTADO DE ACTIVIDADES.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "3. ESTADO ANALITICO DEL ACTIVO",
        "file_item_url": "../../contenido/transparencia/saf/2014/INFORMACION CONTABLE/4TO TRIMESTRE/3. ESTADO ANALITICO DEL ACTIVO.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "4. ESTADO DE FLUJO DE EFECTIVO",
        "file_item_url": "../../contenido/transparencia/saf/2014/INFORMACION CONTABLE/4TO TRIMESTRE/4. ESTADO DE FLUJO DE EFECTIVO.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "5. ESTADO DE VARIACION EN LA HACIENDA PUBLICA",
        "file_item_url": "../../contenido/transparencia/saf/2014/INFORMACION CONTABLE/4TO TRIMESTRE/5. ESTADO DE VARIACION EN LA HACIENDA PUBLICA.pdf"
      }
    ]
  },
  {
    "titulo_item_nombre": "INFORMACIÓN CONTABLE TERCER TRIMESTRE 2014",
    "archivos": [
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "1. ESTADO DE SITUACIÓN FINANCIERA",
        "file_item_url": "../../contenido/transparencia/saf/2014/INFORMACION CONTABLE/3ER TRIMESTRE/1. ESTADO DE SITUACION FINANCIERA.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "2. ESTADO DE ACTIVIDADES",
        "file_item_url": "../../contenido/transparencia/saf/2014/INFORMACION CONTABLE/3ER TRIMESTRE/2. ESTADO DE ACTIVIDADES.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "3. ESTADO ANALITICO DEL ACTIVO",
        "file_item_url": "../../contenido/transparencia/saf/2014/INFORMACION CONTABLE/3ER TRIMESTRE/3. ESTADO ANALITICO DEL ACTIVO.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "4. ESTADO DE VARIACIÓN EN LA HACIENDA PÚBLICA",
        "file_item_url": "../../contenido/transparencia/saf/2014/INFORMACION CONTABLE/3ER TRIMESTRE/4. ESTADO DE VARIACIÓN EN LA HACIENDA PUBLICA.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "5. ESTADO DE FLUJOS DE EFECTIVO",
        "file_item_url": "../../contenido/transparencia/saf/2014/INFORMACION CONTABLE/3ER TRIMESTRE/5. ESTADO DE FLUJOS DE EFECTIVO.pdf"
      }
    ]
  },
  {
    "titulo_item_nombre": "INFORMACIÓN CONTABLE SEGUNDO TRIMESTRE 2014",
    "archivos": [
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "1. ESTADO DE SITUACIÓN FINANCIERA",
        "file_item_url": "../../contenido/transparencia/saf/2014/INFORMACION CONTABLE/2DO TRIMESTRE/1. ESTADO DE SITUACION FINANCIERA.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "2. ESTADO DE ACTIVIDADES",
        "file_item_url": "../../contenido/transparencia/saf/2014/INFORMACION CONTABLE/2DO TRIMESTRE/2. ESTADO DE ACTIVIDADES.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "3. REPORTE ANALITICO DEL ACTIVO",
        "file_item_url": "../../contenido/transparencia/saf/2014/INFORMACION CONTABLE/2DO TRIMESTRE/3. REPORTE ANALITICO DEL ACTIVO.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "4. ESTADO DE FLUJOS DE EFECTIVO",
        "file_item_url": "../../contenido/transparencia/saf/2014/INFORMACION CONTABLE/2DO TRIMESTRE/4. ESTADO DE FLUJOS DE EFECTIVO.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "5. ESTADO DE VARIACIONES EN LA HACIENDA PÚBLICA",
        "file_item_url": "../../contenido/transparencia/saf/2014/INFORMACION CONTABLE/2DO TRIMESTRE/5. ESTADO DE VARIACIONES EN LA HACIENDA PUBLICA.pdf"
      }
    ]
  },
  {
    "titulo_item_nombre": "INFORMACIÓN CONTABLE PRIMER TRIMESTRE 2014",
    "archivos": [
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "Estado Analítico del Activo",
        "file_item_url": "../../contenido/transparencia/saf/2014/INFORMACION CONTABLE/1ER TRIMESTRE/Estado Analitico del Activo.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "Estado de Actividades 1er trimestre 2014",
        "file_item_url": "../../contenido/transparencia/saf/2014/INFORMACION CONTABLE/1ER TRIMESTRE/Estado de Actividades 1er trimestre 2014.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "Situacion Financiera 1er trimestre 2014",
        "file_item_url": "../../contenido/transparencia/saf/2014/INFORMACION CONTABLE/1ER TRIMESTRE/Situacion Financiera 1er trimestre 2014.pdf"
      }
    ]
  },
  {
    "titulo_item_nombre": "CUARTO TRIMESTRE 2015",
    "archivos": [
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "NIVEL FINANCIERO",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/4to TRIMESTRE/NIVEL FINANCIERO.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "POR PROYECTO",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/4to TRIMESTRE/PROYECTOS.pdf"
      }
    ]
  },
  {
    "titulo_item_nombre": "TERCER TRIMESTRE 2015",
    "archivos": [
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "NIVEL FINANCIERO",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/3ER TRIMESTRE/FINANCIERO.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "POR PROYECTO",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/3ER TRIMESTRE/PROYECTOS.pdf"
      }
    ]
  },
  {
    "titulo_item_nombre": "SEGUNDO TRIMESTRE 2015",
    "archivos": [
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "NIVEL FINANCIERO",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/NIVEL FINANCIERO.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "POR PROYECTO",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/PROYECTO.pdf"
      }
    ]
  },
  {
    "titulo_item_nombre": "PRIMER TRIMESTRE 2015",
    "archivos": [
      {
        "extencion":"archivo-pdf",
        "file_item_nombre": "NIVEL FINANCIERO",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/1ER TRIMESTRE/NIVEL FINANCIERO.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "POR PROYECTO",
        "file_item_url": "../../contenido/transparencia/saf/CONTROL PRESUPUESTAL/1ER TRIMESTRE/PROYECTO.pdf"
      }
    ]
  },
  {
    "titulo_item_nombre": "FONDO DE CONTINGENCIAS ECONÓMICAS 2014",
    "img_url":"../../../contenido/transparencia/saf/Fondo ContingenciasE/imgfce.jpg",
    "archivos": [
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "FONDO DE CONTINGENCIAS",
        "file_item_url": "../../contenido/transparencia/saf/Fondo/FONDO DE CONTINGENCIAS .pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "CONVENIO DE FONDO DE CONTINGENCIAS 2014",
        "file_item_url": "../../contenido/transparencia/saf/Fondo ContingenciasE/Convenio de Fondo de Contingencias 2014.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "OFICIOS DE AUTORIZACIÓN CONVENIO DE FONDO DE CONTINGENCIAS 2014",
        "file_item_url": "../../contenido/transparencia/saf/Fondo ContingenciasE/Oficios de Autorización Convenio de Fondo de Contingencias 2014.pdf"
      }
    ]
  },
  {
    "titulo_item_nombre": "FONDEN 2014",
    "img_url":"../../../../contenido/transparencia/saf/FONDEN/imgfd.jpg",
    "archivos": [
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "FIDEICOMISO DE RECONSTRUCCIÓN DE DAÑOS METEOROLÓGICOS",
        "file_item_url": "../../contenido/transparencia/saf/FONDEN/OF_construccion del muro de contencion _001.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "LINEAMIENTOS ESPECÍFICOS DE FONDO DE DESASTRES NATURALES",
        "file_item_url": "../../contenido/transparencia/saf/FONDEN/Lineamientos Específicos de Fondo de Desastres Naturales.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "REGLAS GENERALES DE FONDO DE DESASTRES NATURALES",
        "file_item_url": "../../contenido/transparencia/saf/FONDEN/Reglas Generales de Fondo de Desastres Naturales.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "OFICIOS DE AUTORIZACIÓN DE FONDO DE DESASTRES NATURALES",
        "file_item_url": "../../contenido/transparencia/saf/FONDEN/Oficios de Autorización de Fondo de Desastres Naturales.pdf"
      }
    ]
  },
  {
    "titulo_item_nombre": "FONDO REGIONAL 2014",
    "img_url":"../../../../contenido/transparencia/saf/Fondo/imgfr.jpg",
    "archivos": [
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "FONREGION 2014",
        "file_item_url": "../../contenido/transparencia/saf/Fondo/FONREGION 2014.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "LINEAMIENTOS FONDO REGIONAL 2014",
        "file_item_url": "../../contenido/transparencia/saf/Fondo/Lineamientos Fondo Regional 2014.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "OFICIOS DE AUTORIZACIÓN DE FONDO REGIONAL 2014",
        "file_item_url": "../../contenido/transparencia/saf/Fondo/Oficios de Autorización de Fondo Regional 2014.pdf"
      }
    ]
  },
  {
    "titulo_item_nombre": "DGCES y los SSH",
    "img_url":"../../../../contenido/transparencia/saf/imagDGPLADES.jpg",
    "archivos": [
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "Convenio DGPLADES-CDI-CECTR-HGO012015",
        "file_item_url": "../../contenido/transparencia/saf/DGPLADES/Convenio DGPLADESCDICECTRHGO012015 publicación PO.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "Convenio DGPLADES-CETR-CALIDAD-HGO-01 13",
        "file_item_url": "../../contenido/transparencia/saf/DGPLADES/DGPLADES-CETR-CALIDAD-HGO-01 13.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "Convenio DGPLADES-CALIDAD-CECTR-HGO-01 14",
        "file_item_url": "../../contenido/transparencia/saf/DGPLADES/DGPLADES-CALIDAD-CECTR-HGO-01 14.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "Convenio DGPLADES-CALIDAD-CECTR-HGO-CONV.MODIF-01 15",
        "file_item_url": "../../contenido/transparencia/saf/DGPLADES/DGPLADES-CALIDAD-CECTR-HGO-CONV.MODIF-01 15.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "AVANCE FISICO-FINANCIERO DGPLADES-CALIDAD-CECTR-HGO-01 14",
        "file_item_url": "../../contenido/transparencia/saf/DGPLADES/DGPLADES-CALIDAD-CECTR-HGO-01 14/AVANCE FISICO-FINANCIERO DGPLADES-CALIDAD-CECTR-HGO-01 14.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "AVANCE FISICO Y FINANCIERO DGPLADES-CETR-GV-FOROSS-HGO-0113",
        "file_item_url": "../../contenido/transparencia/saf/DGPLADES/DGPLADES-CETR-GV-FOROSS-HGO-0113/AVANCE FISICO Y FINANCIERO DGPLADES-CETR-GV-FOROSS-HGO-0113.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "DGPLADES-CETR-GV-FOROSS-HGO-0113",
        "file_item_url": "../../contenido/transparencia/saf/DGPLADES/DGPLADES-CETR-GV-FOROSS-HGO-0113/DGPLADES-CETR-GV-FOROSS-HGO-0113.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "DGPLADES-FOROSS-CETR-HGO-0110",
        "file_item_url": "../../contenido/transparencia/saf/DGPLADES/DGPLADES-FOROSS-CETR-HGO-0110/DGPLADES-FOROSS-CETR-HGO-0110.pdf"
      }
    ]
  },
  {
    "titulo_item_nombre": "DGCES y los SSH",
    "img_url":"../../../../contenido/transparencia/saf/imagDGCES.jpg",
    "archivos": [
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "CONVENIO TRANSFERENCIA DE RECURSOS 2015",
        "file_item_url": "../../contenido/transparencia/saf/CONVENIO DE TRANSFERENCIA/CONVENIO TRANSFERENCIA DE RECURSOS 2015.pdf"
      }
    ]
  },
  {
    "titulo_item_nombre": "UNIDADES MEDICAS MOVILES",
    "img_url":"../../../../contenido/transparencia/saf/imag2.jpg",
    "archivos": [
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "CONVENIO UMM 2015",
        "file_item_url": "../../contenido/transparencia/saf/UNIDADES MEDICAS MOVILES/convenio UMM 2015.pdf"
      },
      {
"extencion":"archivo-pdf",
        "file_item_nombre": "SUFICIENCIA DE PRESUPUESTO UMM 2015",
        "file_item_url": "../../contenido/transparencia/saf/UNIDADES MEDICAS MOVILES/suficiencia presupuesto UMM 2015.pdf"
      }
    ]
  }
]